import { URLS } from "constants/urls";
import apiRequests from "utils/apiRequests";

export const fetchClientBasicData = (subDomain) => {
  console.log("API CALL")
  return apiRequests.get(`${URLS.CLIENT_BASIC_DATA}?subdomain=${subDomain}`);
}
